import { InstructionComponentProps } from "../InstructionComponent"

const OuraSetupInstructionPart2: InstructionComponentProps = {
  name: "Oura Ring Setup – Teil 2",
  path: "/help/patient/oura/part2",
  description: "Weitere Schritte, um den Oura Ring einzurichten.",
  both: [
    <>
      Packen Sie den Ring und das Ladegerät aus. Verbinden Sie das
      Ladegerät mit einer USB-Stromquelle, beispielsweise einem Laptop
      oder Netzadapter.
    </>,
    <>
      Die Oura-App wird auf iOS-Geräten mit Apple iOS 15 und höher sowie
      auf Android-Geräten unterstützt, auf denen Android 9 oder höher
      sowie die Google Play-Dienste ausgeführt werden. Ihr Gerät muss
      Bluetooth 4.0 unterstützen.
    </>,
    <>
      Setzen Sie den Ring auf das Ladegerät. Wenn Sie ein Gen3-Ladegerät
      verwenden, blinkt die LED am Ladegerät blau, um anzuzeigen, dass der
      Ring bereit ist, gekoppelt zu werden.
    </>,
    <>
      Vergewissern Sie sich, dass an Ihrem Gerät Bluetooth aktiviert ist.
    </>,
    <>
      Folgen Sie der Anleitung in der App, um Ihr Oura-Konto einzurichten.
    </>
  ]
}

export default OuraSetupInstructionPart2
